import { render, staticRenderFns } from "./OrderPrice.vue?vue&type=template&id=ef9d24b6&scoped=true&"
import script from "./OrderPrice.vue?vue&type=script&lang=js&"
export * from "./OrderPrice.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrice.vue?vue&type=style&index=0&id=ef9d24b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9d24b6",
  null
  
)

export default component.exports